import {
    Box,
    FormControl,
    FormControlProps,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { useState } from "react";
import { EnumDisplay, EnumStringDisplay } from "../../../../model/Enum";

export interface SelectEnumValueProps {
    items: EnumDisplay[];
    defaultValue?: number;
    title?: any;
    sx?: FormControlProps["sx"];
    variant?: FormControlProps["variant"];
    disabled?: boolean;
    onChange?: (value: number) => void;
}

// 输入 enum列表
// 输出: 下拉框div, 选择的enum.value
export function useSelectEnumValue(props: SelectEnumValueProps): [any, number | undefined] {
    const { defaultValue, ...pp } = props;
    const [value, setValue] = useState(defaultValue !== undefined ? defaultValue.toString() : "");
    return [
        <SelectEnumValueDisplay {...pp} value={value} setValue={setValue} />,
        value.length === 0 ? undefined : parseInt(value),
    ];
}

interface SelectEnumValueDisplayProps extends SelectEnumValueProps {
    value: string;
    setValue: (s: string) => void;
}

export function SelectEnumValueDisplay(props: SelectEnumValueDisplayProps) {
    const { items, title, sx, variant, disabled, onChange: onChangeRef, value, setValue } = props;
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {title && <Box sx={{ mr: "10px", display: "flex" }}>{title}：</Box>}
            <FormControl
                size="small"
                variant={variant}
                sx={{ minWidth: "200px", ...sx }}
                disabled={disabled}
            >
                <Select
                    value={value}
                    onChange={(event: SelectChangeEvent) => {
                        setValue(event.target.value);
                        if (onChangeRef !== undefined) {
                            onChangeRef(parseInt(event.target.value));
                        }
                    }}
                    size="small"
                >
                    {items.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}

// 输入 enum列表
// 输出: 下拉框div, 选择的enum.value
export function useSelectEnumString(props: {
    items: EnumStringDisplay[];
    defaultValue?: string;
    title?: string;
    mt?: boolean;
}): [any, string] {
    const { items, defaultValue, title, mt } = props;
    const [value, setValue] = useState(defaultValue !== undefined ? defaultValue : "");
    return [
        <Box sx={{ display: "flex", alignItems: "center", mt: mt ? "30px" : undefined }}>
            {title && <Box sx={{ mr: "10px" }}>{title}：</Box>}
            <FormControl size="small" sx={{ minWidth: "200px" }}>
                <Select
                    value={value}
                    onChange={(event: SelectChangeEvent) => {
                        setValue(event.target.value);
                    }}
                >
                    {items.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>,
        value,
    ];
}

export interface SelectEnumItemProps {
    items: EnumDisplay[];
    title?: string;
}
// 输入 enum列表
// 输出: 下拉框div, 选择的enum
export function useSelectEnumItem(props: SelectEnumItemProps): [any, EnumDisplay | undefined] {
    const { items, title } = props;
    const [index, setIndex] = useState<number | undefined>(undefined);
    return [
        <SelectEnumItemDisplay index={index} setIndex={setIndex} items={items} title={title} />,
        index !== undefined ? items[index] : undefined,
    ];
}

export interface SelectEnumItemDisplayProps extends SelectEnumItemProps {
    index: number | undefined;
    setIndex: (index: number) => void;
}

export function SelectEnumItemDisplay(props: SelectEnumItemDisplayProps) {
    const { items, title, index, setIndex } = props;
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {title && <Box sx={{ mr: "10px" }}>{title}：</Box>}
            <FormControl size="small" sx={{ minWidth: "200px" }}>
                <Select
                    value={index !== undefined ? index.toString() : ""}
                    onChange={(event: SelectChangeEvent) => {
                        if (event.target.value.length === 0) {
                            return;
                        }
                        let i = parseInt(event.target.value);
                        setIndex(i);
                    }}
                >
                    {items.map((item, index) => (
                        <MenuItem key={index} value={index.toString()}>
                            {item.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
